import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface OrganisationSlice {
  orgId?: number;
  shownCreditWarning: boolean;
  isOutOfCredits: boolean;
}

const initialState: OrganisationSlice = {
  orgId: undefined,
  shownCreditWarning: true,
  isOutOfCredits: false
} satisfies OrganisationSlice;

const organisationSlice = createSlice({
  name: "organisation",
  initialState,
  reducers: {
    setOrgId(state, action: PayloadAction<number>) {
      state.orgId = action.payload;
    },
    setShownCreditWarning(state, action: PayloadAction<boolean>) {
      state.shownCreditWarning = action.payload;
    },
    setIsOutOfCredits(state, action: PayloadAction<boolean>) {
      state.isOutOfCredits = action.payload;
    }
  },
  selectors: {
    selectOrgId(state) {
      return state.orgId;
    },
    selectShownCreditWarning(state) {
      return state.shownCreditWarning;
    },
    selectIsOutOfCredits(state) {
      return state.isOutOfCredits;
    }
  }
});

export const { setOrgId, setShownCreditWarning, setIsOutOfCredits } = organisationSlice.actions;
export const { selectOrgId, selectShownCreditWarning, selectIsOutOfCredits } = organisationSlice.selectors;
export default organisationSlice.reducer;
